<!--Method for displaying many images in carousel format (ideal if 
    number of images is a multiple of 6 or 3-->

<template>
  <main>
    {{toImageArray()}}
    <mdb-container v-if="block.value.title_and_text" class="justify-content-center default-color">
      <mdb-row class="pt-5"> 
        <mdb-col class="text-center">
          <h2 v-if="block.value.title_and_text.title" class="pb-2">
            <strong>{{block.value.title_and_text.title}}</strong>
          </h2>
          <p v-if="block.value.title_and_text.text">{{block.value.title_and_text.text}}</p>  
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <mdb-container>
      <mdb-carousel
        :items="numCarouselPages"
        multi
        slide
        indicators
        touch
        :interval="8000"
      >
        <template v-for="(i, index) in items" #[index+1]>
          <div :key="index" style="cursor: pointer">
            <mdb-row md="4" class="d-md-inline-block px-2" @click.native="showLightbox(i)">
              <figure>
                  <img :src="images[i]" class="img-fluid" alt />
              </figure>
            </mdb-row>
            <mdb-row md="4" class="d-md-inline-block px-2" @click.native="showLightbox(i + 1)">
              <figure>
                  <img :src="images[i+1]" class="img-fluid" alt />
              </figure>
            </mdb-row>
          </div>
        </template>
      </mdb-carousel>
      <mdb-lightbox :visible="visible" :imgs="images" :index="index" @hide="handleHide"></mdb-lightbox>
    </mdb-container>
  </main>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbCarousel, mdbLightbox, mdbLazyLoad } from "mdbvue";
export default {
  name: "ImageCarousel",
  props: {
    block: Object,
    colorscheme: String
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCarousel,
    mdbLightbox
  },
  directives: {
    mdbLazyLoad
  },
  data() {
    return {
      images: [],
      visible: false,
      index: 0
    };
  },
  methods: {
    toImageArray: function() {
      var num_images = this.block.value.image_block.length;
      for (var i = 0; i < num_images; i++) {
        var image = "" + this.block.value.image_block[i].value.image.image.src
        this.images[i] = image;
      }
    },
    showLightbox(index) {
      this.index = index;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    }
  },
  computed: {
    items() {
      return this.images.map((_, i) => i).filter((_, i) => i % 2 === 0);
    },
    numCarouselPages() {
      return this.block.value.image_block.length / 2;
    }
  }
};
</script>